import moment from 'moment';
import 'moment/locale/ko';

/**
 * 날짜를 "YYYY. MM. DD" 형식으로 포맷팅하는 함수
 * @param {string|Date} value - 날짜 값
 * @returns {string} 포맷된 날짜 문자열
 */

const formatDate = (value) => {
  const date = moment(value);
  const month = String(date.month() + 1).padStart(2, '0');
  const day = String(date.date()).padStart(2, '0');
  return `${date.year()}. ${month}. ${day}`;
};

export default formatDate;
